"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _Availability2 = _interopRequireDefault(require("MeetingsBase/models/Availability"));

function toMilliseconds(availability) {
  return availability.reduce(function (reduction, day, key) {
    return reduction.set(key, day.map(function (timeRange) {
      return timeRange.toMilliseconds();
    }));
  }, new _immutable.Map());
}

var AvailabilityMilliseconds =
/*#__PURE__*/
function (_Availability) {
  (0, _inherits2.default)(AvailabilityMilliseconds, _Availability);

  function AvailabilityMilliseconds() {
    (0, _classCallCheck2.default)(this, AvailabilityMilliseconds);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AvailabilityMilliseconds).apply(this, arguments));
  }

  (0, _createClass2.default)(AvailabilityMilliseconds, null, [{
    key: "from",
    value: function from(data) {
      if (!data || Object.keys(data).length === 0) {
        return new AvailabilityMilliseconds((0, _get2.default)((0, _getPrototypeOf2.default)(AvailabilityMilliseconds), "from", this).call(this, data));
      }

      return this.fromAvailability(_Availability2.default.from(data));
    }
  }, {
    key: "fromAvailability",
    value: function fromAvailability(availability) {
      /**
       * @param {Availability} availability Configured weekly availability
       * @returns {AvailabilityMilliseconds} Configured weekly availability, expressed in
       * millisecond timestamps
       */
      if (!availability || Object.keys(availability).length === 0) {
        return new AvailabilityMilliseconds();
      }

      var availabilityInMilliseconds = toMilliseconds(availability);
      return new AvailabilityMilliseconds(availabilityInMilliseconds);
    }
  }]);
  return AvailabilityMilliseconds;
}(_Availability2.default);

exports.default = AvailabilityMilliseconds;
module.exports = exports.default;